import { createContext, useContext } from 'react'
import type { SessionState, SessionUser } from './sessionClient'
export type { SessionUser }
export type SessionStatus = SessionState['status']
export interface Session extends SessionState {
  readonly signIn: (returnTo?: string) => void
  readonly signOut: () => void
  readonly refresh: () => Promise<void>
  readonly retry: () => void
}
export const SessionContext = createContext<Session | null>(null)
export function useSession(): Session {
  const session = useContext(SessionContext)
  if (!session) throw new Error('Session provider is required.')
  return session
}
